import { useRef } from "react";

export const defaultItemToString = function <Item>(item: Item | null) {
  return item != null ? String(item) : "";
};

export const defaultItemToKey = function <Item>(item: Item | null) {
  return item;
};

export const useDownshiftEnvironment = () => {
  // fix for shadow DOM, see https://gist.github.com/Rendez/1dd55882e9b850dd3990feefc9d6e177
  const wrapperDivRef = useRef<HTMLDivElement | null>(null);

  const shadowRoot = wrapperDivRef.current
    ? wrapperDivRef.current.getRootNode()
    : null;

  const shadowDocument =
    wrapperDivRef.current && shadowRoot ? shadowRoot.ownerDocument : null;

  const environment = shadowDocument
    ? {
        document: shadowDocument,
        addEventListener: shadowDocument.addEventListener.bind(shadowRoot),
        removeEventListener:
          shadowDocument.removeEventListener.bind(shadowRoot),
        Node,
      }
    : undefined;

  return { ref: wrapperDivRef, environment };
};
